// Single source of truth for the site. Rates, specs, coverage, and the
// how-it-works copy all live here so there is one place to change them.

export const SITE = {
  name: 'Golden Mule Rentals',
  phone: '(469) 834-4700',
  phoneHref: 'tel:+14698344700',
  email: 'reedr25@gmail.com',
  city: 'Dallas\u2013Fort Worth, Texas',
};

export const FLEET = [
  {
    id: 'dump-14k-b',
    image: '/arc-dump.jpg',
    images: ['/arc-dump.jpg'],
    unit: 'UNIT 01',
    name: '14K Dump Trailer',
    model: 'ARC BDZ \u2014 14\u2032 \u00d7 83\u2033, 2 ft sides',
    dayRate: 125,
    threeDayRate: 325,
    weekRate: 675,
    specs: [
      { label: 'Deck', value: "14' \u00d7 83\"" },
      { label: 'Sides', value: '24 in' },
      { label: 'GVWR', value: '14,000 lb' },
      { label: 'Volume', value: '\u22487 cu yd' },
      { label: 'Lift', value: '45\u00b0 scissor' },
      { label: 'Bed', value: '10 ga steel' },
    ],
    use: 'Dirt, gravel, concrete, brush, and demo debris. The 45\u00b0 dump angle empties heavy wet material clean instead of stalling halfway, and the tarp kit keeps it legal on the road.',
    tags: ['Tarp kit', 'Slide-in ramps', 'D-rings', 'Bumper pull'],
  },
  {
    id: 'equip-20',
    image: '/equipment-trailer.jpg',
    images: ['/equipment-trailer.jpg'],
    unit: 'UNIT 02',
    // TODO: replace with the real listing specs once the unit is picked up
    name: 'Equipment Trailer',
    model: "20' Deckover \u2014 tandem axle",
    dayRate: 110,
    threeDayRate: 285,
    weekRate: 595,
    specs: [
      { label: 'Deck', value: "20' \u00d7 83\"" },
      { label: 'GVWR', value: '14,000 lb' },
      { label: 'Payload', value: '9,600 lb' },
      { label: 'Ramps', value: "5' slide-in" },
      { label: 'Tie-downs', value: 'D-ring, 4 pt' },
      { label: 'Hitch', value: 'Bumper pull' },
    ],
    use: 'Skid steer, mini ex, tractor, or a vehicle. Car straps come with it at no extra charge, so you are not hunting for tie-downs the morning of.',
    tags: ['Car straps included', 'Slide-in ramps', 'Bumper pull'],
  },
  {
    id: 'utility-12',
    image: '/utility-1.jpg',
    images: [
      '/utility-1.jpg',
      '/utility-2.jpg',
      '/utility-3.jpg',
      '/utility-4.jpg',
      '/utility-5.jpg',
    ],
    unit: 'UNIT 03',
    name: '12\u2032 Utility Trailer',
    model: 'Texas Bragg U2 \u2014 12\u2032 \u00d7 77\u2033',
    dayRate: 50,
    threeDayRate: 130,
    weekRate: 275,
    specs: [
      { label: 'Deck', value: "12' \u00d7 77\"" },
      { label: 'GVWR', value: '2,995 lb' },
      { label: 'Deck material', value: '2\u2033 treated pine' },
      { label: 'Gate', value: "4' ramp gate" },
      { label: 'Rails', value: '2\u215c\u2033 pipe top' },
      { label: 'Hitch', value: 'Bumper pull' },
    ],
    use: 'Mowers, ATVs, furniture, lumber, and yard cleanup. Single axle and light enough to pull behind a half-ton or an SUV without a brake controller.',
    tags: ['Ramp gate', 'Spare tire', 'No brake controller', 'Bumper pull'],
  },
];

export const RATES = {
  rows: [
    {
      label: 'Dump trailer (Unit 01)',
      day: '$125',
      threeDay: '$325',
      week: '$675',
    },
    {
      label: 'Equipment trailer (Unit 02)',
      day: '$110',
      threeDay: '$285',
      week: '$595',
    },
    {
      label: 'Utility trailer (Unit 03)',
      day: '$50',
      threeDay: '$130',
      week: '$275',
    },
  ],
  delivery: [
    { label: 'Pick up yourself', fee: 'Free' },
    { label: '0-10 miles', fee: '$40 round trip' },
    { label: '10-25 miles', fee: '$60 round trip' },
    { label: '25-50 miles', fee: '$100 round trip' },
    { label: 'Over 50 miles', fee: 'Quoted' },
  ],
  note: 'Rates are flat. No fuel surcharge, no environmental fee, no per-mile add-on. Longer rentals prorate at the best rate that fits \u2014 you never pay more for keeping it longer.',
};

export const COVERAGE = [
  'McKinney',
  'Melissa',
  'Anna',
  'Princeton',
  'Prosper',
  'Celina',
  'Frisco',
  'Allen',
  'Plano',
  'Wylie',
  'Sherman',
  'Van Alstyne',
  'Little Elm',
  'The Colony',
  'Richardson',
  'Garland',
];

export const STEPS = [
  {
    n: '01',
    title: 'Send your dates',
    body: 'Pick a trailer and the days you need it. Takes about a minute. We text back to confirm the unit is free before anything is booked.',
  },
  {
    n: '02',
    title: 'Grab it, or we bring it',
    body: 'Pickup is free and the lot has 24/7 access \u2014 we text you the address once you book. Prefer it dropped? Delivery is a flat fee by distance, set on site before 8 a.m.',
  },
  {
    n: '03',
    title: 'Bring it back or text us',
    body: 'Drop it back at the lot whenever you are done, or text and we pick it up the next morning. No yard hours, no waiting on a gate.',
  },
];
